import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './navalur.css';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  FaMapMarkerAlt, FaPhone, FaCalendarCheck, FaLeaf,
  FaTooth, FaHospital, FaArrowRight, FaCheckCircle,
  FaGlobe, FaWhatsapp, FaClock, FaStar,
  FaUserMd, FaAward, FaHeartbeat,
  FaRegLightbulb, FaShieldAlt, FaCertificate, FaUserCheck, FaCoins, FaUserShield, FaWallet,FaCheck, 
  FaLocationArrow,
  FaDirections 
} from 'react-icons/fa';
import { GiHairStrands, GiMedicalDrip, GiMedicalPack } from 'react-icons/gi';
import { MdFace, MdHealthAndSafety, MdOutlineHealthAndSafety, MdSupportAgent } from 'react-icons/md';
import { RiMentalHealthFill } from 'react-icons/ri';
import { BiBody } from 'react-icons/bi';
import navalurskin from '../../../assets/images/tambaramskinicon.png';
import navalurhai from '../../../assets/images/tambaramhairicon1.png';
import navalurleaf from '../../../assets/images/tambaramleaf.jpg';
import navalurbanner3 from '../../../assets/images/tambarambanner4.png';
// Import combined Before-After images
import img1 from "../../../assets/images/autoscroll1.jpg";
import img2 from "../../../assets/images/autoscroll2.jpg";
import img3 from "../../../assets/images/autoscroll3.jpg";
import img4 from "../../../assets/images/autoscroll4.jpg";
import img5 from "../../../assets/images/autoscroll5.jpg";
import img6 from "../../../assets/images/autoscroll6.jpg";
import img7 from "../../../assets/images/autoscroll7.jpg";
import img8 from "../../../assets/images/autoscroll8.jpg";
import img9 from "../../../assets/images/autoscroll9.jpg";
import img10 from "../../../assets/images/autoscroll10.jpg";
import img11 from "../../../assets/images/autoscrollskin1.png";
import img12 from "../../../assets/images/autoscrollskin2.png";
import img13 from "../../../assets/images/autoscrollskin3.png";
import img14 from "../../../assets/images/autoscrollskin4.png";
import img15 from "../../../assets/images/autoscrollskin5.png";
import img16 from "../../../assets/images/autoscrollskin6.png";
import img17 from "../../../assets/images/autoscrollskin7.png";
import img18 from "../../../assets/images/autoscrollskin8.png";
import img19 from "../../../assets/images/autoscrollskin9.png";
import img20 from "../../../assets/images/autoscrollskin10.png"; 



import chennainavalurm from '../../../assets/images/chennaitambarmhair.jpg';
import chennainavalurskin from '../../../assets/images/chennaitambaramskin.jpg';
import chennainavalurhoeopathy from '../../../assets/images/chennaitambaramhomeopathy.png';
import chennainavalurskin1 from '../../../assets/images/chennaitambaramskin1.jpg';
import chennainavalurskin2 from '../../../assets/images/chennaitambaramskin2.jpg';
import chennainavalurprp from '../../../assets/images/chennaitambaramprp.jpg';
import chennainavalurgfc from '../../../assets/images/chennaitambarmgfc.png';
import chennainavaluraniage from '../../../assets/images/chennaitambaramantiaging.jpg';
import chennainavaluranstm from '../../../assets/images/chennaitambaramstm1.jpg';
import chennainavalurdental from '../../../assets/images/chennaitambarmdental.jpg';
import chennainavalurdental1 from '../../../assets/images/chennaitambaramdental1.jpg';
import chennainavalurdentalinvisible from '../../../assets/images/chennaitambaramdentalinvisible.jpg';
import chennainavalurpcod from '../../../assets/images/chennaitambarampcos.jpg';
import chennainavalurchronic from '../../../assets/images/chennaitambaramchronic.png';
import chennainavalurmentalhealth from '../../../assets/images/chennaitambarammentalhealth.jpg';
import laser1 from "./../../../assets/images/advanced-laser.jpg";
import chennainavaluracne from '../../../assets/images/chennaitambaramacne.jpg';

import chennainavalurcustamized from '../../../assets/images/chennaitambaramcustamized.png';
import chennainavalurpcos from '../../../assets/images/chennaitambarampcos1.jpg';
import chennainavalurfaceprp from '../../../assets/images/chennaitambaramfaceprp.jpg';
import chennainavalurc02 from '../../../assets/images/chennaitambaramc02.jpg';
import chennainavalurrootcanal from '../../../assets/video/chennaitambaramrootcanal.mp4';
import chennainavaluriplant from '../../../assets/images/chennaitambaramimplant.jpg';
import chennainavalurinfertility from '../../../assets/images/chennaitambaraminfertility.jpg';
import chennainavalureczema from '../../../assets/images/chennaitambarameczema.jpg';

import hcuraHeroVideo1 from '../../../assets/video/hcura-hero6.mp4';
import hcuraHeroVideo2 from '../../../assets/video/hcura-hero4.mp4';
import hcuraHeroVideo from '../../../assets/video/hcura-hero2.mp4';

const ICON_MAP = {
  'quality-icon': FaAward,
  'personalized-icon': FaUserCheck,
  'affordable-icon': FaCoins
};

const Icon = ({ name, size = 24, className = '', ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const HCuraNavalur = () => {
  const [activeLocation, setActiveLocation] = useState('navalur');
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);
useEffect(() => {
  document.title = "H-Cura Multispecialty Clinic Navalur Chennai | Hair, Skin, Dental & Homeopathy Treatments";
  
  const metaDescription = document.querySelector("meta[name='description']");
  if (metaDescription) {
    metaDescription.setAttribute(
      "content",
      "H-Cura Multispecialty Clinic in Navalur Chennai offers advanced Hair Fall Treatment, Skin Care, Dental Solutions, and Homeopathy. Expert doctors, modern technology, proven results for Navalur, OMR, Sholinganallur areas."
    );
  }
  
  const metaKeywords = document.querySelector("meta[name='keywords']");
  if (metaKeywords) {
    metaKeywords.setAttribute(
      "content",
      "H-Cura Navalur, Hair Treatment Navalur, Skin Clinic Navalur, Dental Care Navalur, Homeopathy Navalur, PRP Hair Treatment, HydraFacial, Root Canal, PCOS Treatment, multispecialty clinic Chennai, hair fall treatment Chennai, skin whitening Navalur, dental implants Chennai, homeopathy clinic Chennai, laser hair removal Navalur"
    );
  }
  
  const existingCanonical = document.querySelector("link[rel='canonical']");
  if (existingCanonical) {
    existingCanonical.setAttribute("href", "https://h-cura.com/multispecialty-clinic-in-navalur-chennai");
  } else {
    const canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", "https://h-cura.com/multispecialty-clinic-in-navalur-chennai/");
    document.head.appendChild(canonicalLink);
  }
}, []);

  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  const [navalurBaModalOpen, setNavalurBaModalOpen] = useState(false);
  const [navalurBaModalItems, setNavalurBaModalItems] = useState([]);
  const [navalurBaModalStartIndex, setNavalurBaModalStartIndex] = useState(0);

  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const scrollGallery = (direction) => {
    const container = document.getElementById('scrollableGrid');
    const cardWidth = 420;
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;
    
    let newScrollPosition;
    if (direction === 'next') {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }
    
    container.scrollTo({
      left: newScrollPosition,
      behavior: 'smooth'
    });
    
    updateScrollIndicators();
  };

  const updateScrollIndicators = () => {
    const container = document.getElementById('scrollableGrid');
    const progressBar = document.getElementById('progressBar');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    
    if (!container || !progressBar) return;
    
    const scrollPercentage = (container.scrollLeft / (container.scrollWidth - container.clientWidth)) * 100;
    progressBar.style.width = `\${scrollPercentage}%`;
    
    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn) nextBtn.disabled = container.scrollLeft >= (container.scrollWidth - container.clientWidth - 10);
  };

  useEffect(() => {
    if (navalurBaModalOpen) {
      const container = document.getElementById('scrollableGrid');
      if (container) {
        container.addEventListener('scroll', updateScrollIndicators);
        updateScrollIndicators();
        
        const cardWidth = 420;
        container.scrollLeft = navalurBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener('scroll', updateScrollIndicators);
        };
      }
    }
  }, [navalurBaModalOpen, navalurBaModalStartIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start('visible');
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }

    if (!isAutoScrollPaused) {
      autoScrollRef.current = setInterval(() => {
        setActiveService(prev => {
          const next = (prev + 1) % advancedServices.length;
          setIsChanging(true);
          setTimeout(() => {
            setIsChanging(false);
          }, 300);
          return next;
        });
      }, 10000);
    }

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
        autoScrollRef.current = null;
      }
    };
  }, [isAutoScrollPaused]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12,
      },
    },
  };

 const locations = {
    navalur: {
   name: "Navalur",
   address: "OMR Road, Navalur, Chennai, Tamil Nadu 600130",
   phone: "+91 88700 01377",
   hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
   nearbyAreas: "Sholinganallur, Perungudi, Thoraipakkam",
   popularServices: [
     "PRP Hair Treatment",
     "Dental Fillings",
     "Acne & Skin Lightening",
     "Root Canal and Smile Design"
   ],
   specialties: "Hair Restoration & Dental Procedures",
   mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Navalur+Chennai",
   video: hcuraHeroVideo1
 },
 valasaravakkam: {
   name: "Valasaravakkam",
   address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
   phone: "+91 88700 01377",
   hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
   nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
   popularServices: [
     "Braces and Orthodontics",
     "GFC Hair Therapy",
     "Pigmentation & Skin Whitening",
     "Anxiety & PCOS Homeopathy Treatment"
   ],
   specialties: "Skin Treatments & Women's Health",
   mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai",
   video: hcuraHeroVideo1
 },
 gerugambakkam: {
   name: "Gerugambakkam",
   address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
   phone: "+91 88700 01377", 
   hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
   nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
   popularServices: [
     "Hair Loss Treatment",
     "Skin Problem Solutions", 
     "Complete Dental Care",
     "Natural Homeopathy Treatment"
   ],
   specialties: "Complete Healthcare Solutions",
   mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai",
   video: hcuraHeroVideo1
 },
 tambaram: {
   name: "Tambaram",
   address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
   phone: "+91 88700 01377",
   hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
   nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
   popularServices: [
     "PRP Hair Treatment",
     "Dental Fillings",
     "Acne & Skin Lightening",
     "Root Canal and Smile Design"
   ],
   specialties: "Hair Restoration & Dental Procedures",
   mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai",
   video: hcuraHeroVideo1
 }
   };

  const advancedServices = [
    {
      id: 'hair',
      title: 'Hair Advanced Treatments in Navalur – PRP, GFC',
      subtitle: 'Restore Your Confidence',
      description: 'If you are struggling with hair thinning or bald patches, our Hair Fall Treatment in Navalur is designed to give you visible results.',
      image: chennainavalurm,
      treatments: [
       {
  name: 'Laser Hair Removal Navalur',
  description: 'Advanced laser technology for permanent hair reduction.',
  icon: 'laser-icon',
  image: laser1,
  benefits: ['Permanent hair reduction', 'Smooth skin results', 'Safe and effective', 'Long-lasting solution']
},
        {
          name: 'GFC Hair Treatment Navalur',
          description: 'Advanced GFC therapy uses concentrated growth factors from your own blood to accelerate hair regeneration.',
          icon: 'gfc-icon',
          image: chennainavalurgfc,
          benefits: ['Faster regrowth', 'Thicker hair density', 'Natural-looking results', 'Customized formulation']
        },
        {
          name: 'Customized Hair Fall Control Plans',
          description: 'Customized Hair Fall Control Plans offer personalized treatment combining GFC Hair Therapy with PRP Treatment after detailed scalp analysis, delivering permanent results with natural hairline design, minimal scarring, and quick recovery.',
          icon: 'prp-icon',
          image: chennainavalurcustamized,
          benefits: ['Permanent results', 'Natural hairline design', 'Minimal scarring', 'Quick recovery']
        }
      ],
      testimonial: {
        quote: "After trying numerous products with no success, the PRP and GFC combination treatment at H-Cura completely transformed my hair. I've regained not just my hair, but my confidence too.",
        author: "Rajesh K.",
        location: "Sholinganallur"
      }
    },
    {
      id: 'skin',
      title: 'Skin Treatments in Navalur – From Acne to Anti-Aging',
      subtitle: 'Radiant Skin, Timeless Beauty',
      description: 'Our Skin Clinic in Navalur offers advanced dermatology and aesthetic care to help you look your best.',
      image: chennainavalurskin,
      treatments: [
      {
  name: 'Advanced Acne Treatment in Navalur',
  description: 'Comprehensive acne treatment combining medical-grade therapies, targeted extractions, and specialized serums to clear breakouts, reduce inflammation, and prevent future acne formation.',
  icon: 'acne-treatment-icon',
  image: chennainavaluracne,
  benefits: ['Clears active breakouts', 'Reduces acne scars', 'Controls oil production', 'Prevents future acne', 'Anti-inflammatory therapy']
},

       {
  name: 'PRP Face Treatment Navalur',
  description: 'Platelet-Rich Plasma therapy using your own blood to stimulate collagen production, reduce fine lines, and rejuvenate skin naturally for a youthful glow.',
  icon: 'pigmentation-icon',
  image: chennainavalurfaceprp,
  benefits: ['Natural skin rejuvenation', 'Stimulates collagen growth', 'Reduces fine lines', 'Improves skin texture', 'Long-lasting results']
},

        {
  name: 'CO2 Carbon Facial Navalur',
  description: 'Advanced carbon dioxide laser facial treatment that deeply exfoliates, tightens pores, stimulates collagen production, and instantly brightens skin for a refreshed, youthful appearance.',
  icon: 'carbon-facial-icon',
  image: chennainavalurc02,
  benefits: ['Deep pore cleansing', 'Instant skin tightening', 'Reduces blackheads', 'Stimulates collagen', 'No downtime required']
}

      ],
      testimonial: {
        quote: "The HydraFacial treatment at H-Cura gave me instant results that just kept getting better. My skin hasn't looked this good in years!",
        author: "Priya M.",
        location: "Navalur"
      }
    },
    {
      id: 'dental',
      title: 'Dental Care in Navalur – Advanced, Painless & Affordable',
      subtitle: 'Perfect Smiles, Painlessly Delivered',
      description: 'Your smile is your biggest asset, and our Dental Clinic in Navalur ensures it stays perfect.',
      image: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      treatments: [
       {
  name: 'Root Canal Treatment Navalur',
  description: 'Pain-free, quick recovery, and lasting results.',
  icon: 'smile-icon',
  video: chennainavalurrootcanal,
  benefits: ['Preview results', 'Customized planning', 'Precise implementation', 'Stunning aesthetics']
},
        {
          name: 'Dental Implants Navalur',
          description: 'Replace missing teeth with permanent, natural-looking solutions.',
          icon: 'rootcanal-icon',
          image: chennainavaluriplant,
          benefits: ['Pain-free procedure', 'Single-sitting options', 'Preserves natural tooth', 'Long-lasting results']
        },
        {
          name: 'Invisible Orthodontics',
          description: 'Clear aligner technology for teeth straightening without metal braces, custom-designed for your smile.',
          icon: 'aligner-icon',
          image: chennainavalurdentalinvisible,
          benefits: ['Nearly invisible', 'Removable aligners', 'Comfortable fit', 'Fewer clinic visits']
        }
      ],
      testimonial: {
        quote: "The digital smile design process at H-Cura let me see my new smile before committing to treatment. The results are even better than I imagined!",
        author: "Vikram S.",
        location: "Perungudi"
      }
    },
    {
      id: 'homeopathy',
      title: 'Homeopathy in Navalur – Natural Healing for All Ages',
      subtitle: 'Natural Healing, Lasting Wellness',
      description: "Classical homeopathic treatments integrated with modern medical understanding for comprehensive health solutions and Our Homeopathy Clinic in Navalur provides safe, effective, and long-lasting relief for various health conditions",
      image: chennainavalurhoeopathy,
      treatments: [
    {
  name: 'Eczema Treatment in Navalur',
  description: 'Struggling with itchy, irritated skin? Our eczema specialists in Navalur help you find real relief. We create a treatment plan just for you to calm your skin, reduce flare-ups, and get back to feeling comfortable in your own skin.',
  icon: 'constitutional-icon',
  image: chennainavalureczema,
  benefits: ['Stops the itch', 'Treats root cause', 'Safe for all ages', 'Quick relief']
},

{
  name: 'PCOS/PCOD Treatment in Navalur',
  description: 'Specialized homeopathic protocols to regulate hormones naturally and address PCOS/PCOD symptoms effectively. Comprehensive treatment for hormonal balance, menstrual regulation, and metabolic health restoration.',
  icon: 'hormonal-icon',
  image: chennainavalurpcos,
  benefits: ['Regulates cycles', 'Reduces symptoms', 'Balances hormones', 'Improves fertility', 'Manages weight', 'Controls insulin resistance']
},

        {
          name: 'Infertility Treatment in Navalur',
          description: 'At H-Cura, we provide personalized infertility treatment in Navalur designed to address the underlying causes of reproductive challenges. Our approach blends modern diagnostic methods with natural and holistic therapies to improve fertility and overall reproductive health',
          icon: 'chronic-icon',
          image: chennainavalurinfertility,
          benefits: ['Reduces dependency on conventional drugs', 'Improves quality of life', 'Addresses underlying causes', 'Safe for all ages']
        }
      ],
      testimonial: {
        quote: "After years of struggling with PCOS and trying conventional treatments, H-Cura's homeopathic approach has finally regulated my cycles naturally.",
        author: "Divya R.",
        location: "Thoraipakkam"
      }
    }
  ];

  const testimonials = [
    {
      name: "Priya R.",
      location: "Navalur",
      text: "The PRP treatment at H-Cura completely transformed my hair loss problem. The doctors were thorough in their diagnosis and treatment plan.",
      rating: 5,
      service: "Hair Treatment"
    },
    {
      name: "Karthik M.",
      location: "Sholinganallur",
      text: "After struggling with chronic acne for years, the homeopathic approach at H-Cura finally gave me clear skin. Highly recommend their skin treatments.",
      rating: 5,
      service: "Skin Treatment"
    },
    {
      name: "Divya S.",
      location: "Perungudi",
      text: "The dental team made my root canal procedure completely painless. Their modern facilities and caring approach made all the difference.",
      rating: 4,
      service: "Dental Care"
    }
  ];

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Prime Location",
      description: "Situated in Navalur on OMR, Chennai, our clinic is easily accessible to Sholinganallur, Perungudi, and Thoraipakkam residents with excellent transport connectivity.",
      highlight: "Easy Access"
    },
    {
      icon: <FaUserMd />,
      title: "Expert Specialists",
      description: "Whether you're looking for Hair Loss Treatment, Skin Rejuvenation, Smile Designing, or Homeopathy, our multi-specialty doctors ensure the right treatment.",
      highlight: "Specialized Care"
    },
    {
      icon: <GiMedicalPack />,
      title: "Advanced Technology",
      description: "We combine cutting-edge medical equipment with clinically proven techniques for PRP Hair Treatment, Laser Skin Treatments, and Digital Dentistry.",
      highlight: "Modern Equipment"
    },
    {
      icon: <FaHeartbeat />,
      title: "Holistic Healing",
      description: "Our Homeopathy Clinic focuses on long-term health improvement — treating the root cause rather than just symptoms with safe, natural remedies.",
      highlight: "Natural Wellness"
    },
    {
      icon: <FaAward />,
      title: "Proven Results",
      description: "With hundreds of success stories, 5-star reviews, and loyal repeat patients, H-Cura Navalur has earned a strong reputation for trust and quality.",
      highlight: "Success Stories"
    },
    {
      icon: <FaRegLightbulb />,
      title: "Personalized Care",
      description: "Our specialist doctors take time to listen, assess, and create customized treatment plans for hair, skin, dental, or overall health needs.",
      highlight: "Tailored Treatments"
    },
    {
      icon: <MdOutlineHealthAndSafety />,
      title: "Safety Standards",
      description: "Stringent sterilization protocols, FDA-approved products, and international hygiene standards ensure your complete safety during treatments.",
      highlight: "Medical Safety"
    },
    {
      icon: <MdSupportAgent />,
      title: "Continuous Support",
      description: "Ongoing follow-ups, emergency assistance, and dedicated patient coordinators guide you throughout your treatment journey for optimal results.",
      highlight: "Patient Support"
    }
  ];

  const testimonialQuotes = [
    "The doctors at H-Cura truly listen and develop personalized treatment plans that work.",
    "After trying many clinics, H-Cura's holistic approach finally solved my chronic skin issues.",
    "Their attention to detail and focus on natural healing methods sets them apart in Chennai."
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case 'hair': return '/advanced-grow-hair-treatment';
      case 'skin': return '/advanced-hydrafacial-treatment';
      case 'dental': return '/dental-treatment';
      case 'homeopathy': return '/homeopathy-best-treatments/';
      default: return '/services';
    }
  };

  const heroBackgroundUrl = navalurbanner3;
  const servicesBackgroundUrl = 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80';

  const serviceIconMap = {
    hair: {
      url: navalurhai,
      bgColor: 'rgba(255,154,158,0.12)',
      borderColor: 'rgba(255,154,158,0.18)',
      color: '#ff4d6d'
    },
    skin: {
      url: navalurskin,
      bgColor: 'rgba(255,223,121,0.12)',
      borderColor: 'rgba(255,223,121,0.18)',
      color: '#ffb400'
    },
    dental: {
      url: 'https://img.icons8.com/fluency/48/000000/tooth.png',
      bgColor: 'rgba(144,238,144,0.12)',
      borderColor: 'rgba(144,238,144,0.18)',
      color: '#28a745'
    },
    homeopathy: {
      url: navalurleaf,
      bgColor: 'rgba(135,206,250,0.12)',
      borderColor: 'rgba(135,206,250,0.18)',
      color: '#0099cc'
    }
  };

  const treatmentIconMap = {
    'prp-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/syringe.png',
      bgColor: 'rgba(255,140,140,0.06)',
      borderColor: 'rgba(255,140,140,0.12)'
    },
    'gfc-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/biotech.png',
      bgColor: 'rgba(170,200,255,0.06)',
      borderColor: 'rgba(110,160,255,0.12)'
    },
    'transplant-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/hair-care.png',
      bgColor: 'rgba(255,230,140,0.06)',
      borderColor: 'rgba(255,200,60,0.12)'
    },
    'hydrafacial-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/spa-care.png',
      bgColor: 'rgba(200,255,230,0.06)',
      borderColor: 'rgba(60,200,120,0.12)'
    },
    'pigmentation-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/foundation-makeup.png',
      bgColor: 'rgba(250,210,255,0.06)',
      borderColor: 'rgba(220,120,240,0.12)'
    },
    'antiaging-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/collagen.png',
      bgColor: 'rgba(220,245,255,0.06)',
      borderColor: 'rgba(80,200,240,0.12)'
    },
    'smile-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/happy-tooth.png',
      bgColor: 'rgba(200,255,220,0.06)',
      borderColor: 'rgba(80,200,120,0.12)'
    },
    'rootcanal-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/tooth-cleaning.png',
      bgColor: 'rgba(255,240,200,0.06)',
      borderColor: 'rgba(240,180,60,0.12)'
    },
    'aligner-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/braces.png',
      bgColor: 'rgba(230,230,255,0.06)',
      borderColor: 'rgba(140,120,240,0.12)'
    },
    'constitutional-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/holistic-therapy.png',
      bgColor: 'rgba(240,240,255,0.06)',
      borderColor: 'rgba(160,160,240,0.12)'
    },
    'hormonal-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/hormone.png',
      bgColor: 'rgba(255,230,240,0.06)',
      borderColor: 'rgba(240,160,200,0.12)'
    },
    'chronic-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/medical-pack.png',
      bgColor: 'rgba(230,255,240,0.06)',
      borderColor: 'rgba(160,240,200,0.12)'
    },
    'laser-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/laser.png',
      bgColor: 'rgba(255,220,220,0.06)',
      borderColor: 'rgba(255,180,180,0.12)'
    },
    'acne-treatment-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/facial-treatment.png',
      bgColor: 'rgba(220,240,255,0.06)',
      borderColor: 'rgba(180,220,255,0.12)'
    },
    'carbon-facial-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/face-mask.png',
      bgColor: 'rgba(240,220,255,0.06)',
      borderColor: 'rgba(220,180,255,0.12)'
    }
  };

  const SAMPLE_GALLERY = {
    hair: [
      {
        id: 'hair-1',
        title: 'Hair Restoration Case 1 - Male Pattern Hair Loss Treatment',
        combined: img1,
        testimonial: { quote: 'Amazing hair transformation in just 6 months with PRP treatment at H-Cura Navalur!', author: 'Rajesh K.' }
      },
      {
        id: 'hair-2',
        title: 'Hair Growth Case 2 - Crown Area Hair Restoration',
        combined: img2,
        testimonial: { quote: 'PRP and GFC therapy gave me incredible results. Highly recommend H-Cura Navalur!', author: 'Amit S.' }
      },
      {
        id: 'hair-3',
        title: 'Hair Treatment Case 3 - Receding Hairline Recovery',
        combined: img3,
        testimonial: { quote: 'My confidence is back with my natural-looking hairline from H-Cura!', author: 'Priya M.' }
      },
    {
        id: 'hair-4',
        title: 'Hair Case 4 - GFC and QR678 Treatment Success',
        combined: img4,
        testimonial: { quote: 'GFC and QR678 treatment gave me natural hair regrowth. Now I don\'t worry about hair loss anymore.', author: 'Karthik R.' }
      },

      {
        id: 'hair-5',
        title: 'Hair Restoration Case 5 - Natural Hair Regrowth',
        combined: img5,
        testimonial: { quote: 'Best decision I made for my hair health. Natural results at H-Cura!', author: 'Deepak V.' }
      },
      {
        id: 'hair-6',
        title: 'Hair Density Case 6 - Hair Volume Enhancement',
        combined: img6,
        testimonial: { quote: 'Visible hair density increase within 3 months of treatment in Navalur.', author: 'Anitha L.' }
      },
      {
        id: 'hair-7',
        title: 'Hair Makeover Case 7 - Complete Hair Transformation',
        combined: img7,
        testimonial: { quote: 'Professional treatment with amazing outcomes. Thank you H-Cura Navalur!', author: 'Suresh K.' }
      },
      {
        id: 'hair-8',
        title: 'Hair Recovery Case 8 - Hairline Restoration Success',
        combined: img8,
        testimonial: { quote: 'My family is amazed by the complete transformation at H-Cura.', author: 'Vikram P.' }
      },
      {
        id: 'hair-9',
        title: 'Hair Growth Case 9 - Hair Volume Enhancement',
        combined: img9,
        testimonial: { quote: 'H-Cura gave me back my youthful appearance and confidence in Navalur.', author: 'Ramesh B.' }
      },
      {
        id: 'hair-10',
        title: 'Hair Treatment Case 10 - Hair Thickness Improvement',
        combined: img10,
        testimonial: { quote: 'Outstanding results that exceeded all my expectations at H-Cura!', author: 'Mahesh T.' }
      }
    ],
    
    skin: [
      {
        id: 'skin-1',
        title: 'Skin Treatment Case 1 - Acne Removal Success',
        combined: img11,
        testimonial: { quote: 'Clear skin after years of struggling with acne at H-Cura Navalur!', author: 'Sneha R.' }
      },
      {
        id: 'skin-2',
        title: 'Skin Care Case 2 - Pigmentation Removal Treatment',
        combined: img12,
        testimonial: { quote: 'HydraFacial gave me the glow I always wanted in Navalur.', author: 'Kavya M.' }
      },
      {
        id: 'skin-3',
        title: 'Anti-Aging Case 3 - Wrinkle Reduction Treatment',
        combined: img13,
        testimonial: { quote: 'Wrinkles reduced significantly with laser treatment at H-Cura.', author: 'Meera K.' }
      },
      {
        id: 'skin-4',
        title: 'Skin Whitening Case 4 - Skin Tone Improvement',
        combined: img14,
        testimonial: { quote: 'Even skin tone achieved naturally and safely in Navalur.', author: 'Preethi S.' }
      },
      {
        id: 'skin-5',
        title: 'Melasma Treatment Case 5 - Dark Spot Removal',
        combined: img15,
        testimonial: { quote: 'Dark patches completely gone after treatment at H-Cura!', author: 'Divya L.' }
      },
      {
        id: 'skin-6',
        title: 'Skin Rejuvenation Case 6 - Youthful Skin Restoration',
        combined: img16,
        testimonial: { quote: 'Youthful skin restored with advanced treatments in Navalur.', author: 'Anjali P.' }
      },
      {
        id: 'skin-7',
        title: 'Acne Scar Case 7 - Scar Removal Treatment',
        combined: img17,
        testimonial: { quote: 'Smooth skin texture achieved after scar treatment at H-Cura.', author: 'Rohit M.' }
      },
      {
        id: 'skin-8',
        title: 'Dark Circle Case 8 - Under Eye Treatment',
        combined: img18,
        testimonial: { quote: 'Bright, refreshed eyes after under-eye treatment in Navalur.', author: 'Lakshmi V.' }
      },
      {
        id: 'skin-9',
        title: 'Skin Tightening Case 9 - Firm Skin Treatment',
        combined: img19,
        testimonial: { quote: 'Firm, tight skin without surgery. Amazing results at H-Cura!', author: 'Sunita K.' }
      },
      {
        id: 'skin-10',
        title: 'Overall Skin Health Case 10 - Complete Skin Transformation',
        combined: img20,
        testimonial: { quote: 'Complete skin transformation with holistic approach in Navalur.', author: 'Ravi S.' }
      }
    ],
    
    dental: [
      {
        id: 'dental-1',
        title: 'Dental Case 1 - Smile Makeover Transformation',
        combined: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Perfect smile achieved with digital smile design at H-Cura Navalur!', author: 'Arun K.' }
      },
      {
        id: 'dental-2',
        title: 'Teeth Whitening Case 2 - Bright White Smile',
        combined: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Bright, white teeth in just one session in Navalur!', author: 'Priya R.' }
      },
      {
        id: 'dental-3',
        title: 'Dental Implants Case 3 - Missing Tooth Replacement',
        combined: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Natural-looking teeth replacement. Excellent work at H-Cura!', author: 'Suresh M.' }
      },
      {
        id: 'dental-4',
        title: 'Orthodontic Case 4 - Straight Teeth Treatment',
        combined: 'https://images.unsplash.com/photo-1601568544619-9e77545a0c94?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Straight teeth with invisible braces. Amazing results in Navalur!', author: 'Kavitha S.' }
      },
      {
        id: 'dental-5',
        title: 'Root Canal Case 5 - Pain-Free Tooth Treatment',
        combined: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Painless root canal treatment. Saved my tooth at H-Cura!', author: 'Ramesh P.' }
      },
      {
        id: 'dental-6',
        title: 'Gum Treatment Case 6 - Healthy Gums Restoration',
        combined: 'https://images.unsplash.com/photo-1542736667-069246bdbc6d?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Healthy gums restored with laser treatment in Navalur.', author: 'Deepa L.' }
      },
      {
        id: 'dental-7',
        title: 'Crown & Bridge Case 7 - Tooth Restoration',
        combined: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Perfect fit crowns. Natural appearance achieved at H-Cura!', author: 'Vikram R.' }
      },
      {
        id: 'dental-8',
        title: 'Cosmetic Dentistry Case 8 - Beautiful Smile Design',
        combined: 'https://images.unsplash.com/photo-1555708982-8645ec6618c7?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete smile transformation. Confidence restored in Navalur!', author: 'Anitha M.' }
      },
      {
        id: 'dental-9',
        title: 'Kids Dentistry Case 9 - Child-Friendly Treatment',
        combined: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Child-friendly treatment. No more dental fear at H-Cura!', author: 'Sita K.' }
      },
      {
        id: 'dental-10',
        title: 'Full Mouth Case 10 - Complete Dental Restoration',
        combined: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete oral health restored. Life-changing results in Navalur!', author: 'Mahesh V.' }
      }
    ],
    
    homeopathy: [
      {
        id: 'homeopathy-1',
        title: 'PCOS Treatment Case 1 - Hormonal Balance Restoration',
        combined: 'https://images.unsplash.com/photo-1577003833619-76bbd7f82948?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Natural PCOS treatment regulated my cycles perfectly at H-Cura Navalur!', author: 'Divya R.' }
      },
      {
        id: 'homeopathy-2',
        title: 'Chronic Illness Case 2 - Natural Healing Success',
        combined: 'https://images.unsplash.com/photo-1505751171710-1f6d0ace5a85?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Holistic approach cured my chronic condition naturally in Navalur.', author: 'Raj M.' }
      },
      {
        id: 'homeopathy-3',
        title: 'Infertility Treatment Case 3 - Fertility Restoration',
        combined: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Blessed with a baby after homeopathic treatment at H-Cura!', author: 'Preethi S.' }
      },
      {
        id: 'homeopathy-4',
        title: 'Anxiety Treatment Case 4 - Mental Health Improvement',
        combined: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Mental peace achieved through natural remedies in Navalur.', author: 'Arjun K.' }
      },
      {
        id: 'homeopathy-5',
        title: 'Digestive Issues Case 5 - Stomach Problem Relief',
        combined: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Digestive problems resolved without side effects at H-Cura.', author: 'Meera L.' }
      },
      {
        id: 'homeopathy-6',
        title: 'Skin Allergies Case 6 - Allergy Treatment Success',
        combined: 'https://images.unsplash.com/photo-1594824111567-8b5d7e0d5ad6?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Chronic skin allergies cured permanently in Navalur!', author: 'Sundar R.' }
      },
      {
        id: 'homeopathy-7',
        title: 'Respiratory Issues Case 7 - Breathing Problem Relief',
        combined: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Breathing problems resolved with gentle treatment at H-Cura.', author: 'Lakshmi P.' }
      },
      {
        id: 'homeopathy-8',
        title: 'Joint Pain Case 8 - Arthritis Pain Relief',
        combined: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Arthritis pain reduced significantly without drugs in Navalur.', author: 'Raman V.' }
      },
      {
        id: 'homeopathy-9',
        title: 'Migraine Treatment Case 9 - Headache Relief',
        combined: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Chronic migraines eliminated with homeopathy at H-Cura.', author: 'Kavya M.' }
      },
      {
        id: 'homeopathy-10',
        title: 'Overall Wellness Case 10 - Complete Health Transformation',
        combined: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete health transformation through natural healing in Navalur.', author: 'Deepak S.' }
      }
    ]
  };

  const [thumbnailFlipState, setThumbnailFlipState] = useState({
    hair: Array(10).fill(false),
    skin: Array(10).fill(false),
    dental: Array(10).fill(false),
    homeopathy: Array(10).fill(false)
  });

  useEffect(() => {
    const timers = [];
    Object.keys(SAMPLE_GALLERY).forEach((svcKey) => {
      SAMPLE_GALLERY[svcKey].forEach((_, idx) => {
        const t = setInterval(() => {
          setThumbnailFlipState(prev => {
            const copy = { ...prev };
            copy[svcKey] = copy[svcKey].slice();
            copy[svcKey][idx] = !copy[svcKey][idx];
            return copy;
          });
        }, 5000 + idx * 250);
        timers.push(t);
      });
    });
    return () => timers.forEach(t => clearInterval(t));
  }, []);

  const openNavalurBaModal = (serviceKey, startIndex = 0) => {
    setNavalurBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setNavalurBaModalStartIndex(startIndex);
    setNavalurBaModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeNavalurBaModal = () => {
    setNavalurBaModalOpen(false);
    setNavalurBaModalItems([]);
    setNavalurBaModalStartIndex(0);
    document.body.style.overflow = '';
  };

  return (
    <div className="navalur-hcura-chennai">
      <head>
        <title>H-Cura Multispecialty Clinic Navalur Chennai | Hair, Skin, Dental & Homeopathy Treatments</title>
        <meta name="description" content="H-Cura Multispecialty Clinic in Navalur Chennai offers advanced Hair Fall Treatment, Skin Care, Dental Solutions, and Homeopathy. Expert doctors, modern technology, proven results." />
        <meta name="keywords" content="H-Cura Navalur, Hair Treatment Navalur, Skin Clinic Navalur, Dental Care Navalur, Homeopathy Navalur, PRP Hair Treatment, HydraFacial, Root Canal, PCOS Treatment" />
        <meta property="og:title" content="H-Cura Multispecialty Clinic Navalur Chennai" />
        <meta property="og:description" content="Advanced Hair, Skin, Dental & Homeopathy treatments in Navalur. Expert care with proven results." />
        <meta property="og:image" content={navalurbanner3} />
        <meta property="og:url" content="https://h-cura.com/navalur" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://h-cura.com/navalur" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "name": "H-Cura Multispecialty Clinic Navalur",
            "description": "Advanced Hair, Skin, Dental & Homeopathy treatments in Navalur Chennai",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "OMR Road, Navalur",
              "addressLocality": "Navalur",
              "addressRegion": "Chennai",
              "postalCode": "600130",
              "addressCountry": "IN"
            },
            "telephone": "+91 88700 01377",
            "url": "https://h-cura.com",
            "openingHours": "Mo-Su 10:00-20:00",
            "medicalSpecialty": ["Dermatology", "Trichology", "Dentistry", "Homeopathy"],
            "priceRange": "$$"
          })}
        </script>
      </head>

      <section className="navalur-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
  <video
    autoPlay
    muted
    loop
    playsInline
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: -2
    }}
  >
   <source src={hcuraHeroVideo} type="video/mp4" />
  </video>

  <div 
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))',
      zIndex: -1
    }}
  ></div>

  <div className="navalur-hcura-hero-content-wrapper">
    <motion.h1
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="navalur-hcura-primary-title"
    >
      H-Cura Multispecialty Clinic in Navalur Chennai
    </motion.h1>
    
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="navalur-hcura-secondary-title"
    >
      Expert Hair, Skin, Dental & Homeopathy Treatments
    </motion.h2>
    
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.4 }}
      className="navalur-hcura-description-text"
    >
      Welcome to H-Cura Multispecialty Clinic in Navalur Chennai – your trusted destination for Hair Fall Treatment, Skin Care, Dental Solutions, and Natural Homeopathy.
      We combine advanced medical science with natural healing to offer world-class treatments in Hair, Skin, Dental, and Homeopathy – all under one roof.
      Our clinic serves patients from Navalur, Sholinganallur, Perungudi, Thoraipakkam, and nearby areas on OMR.
    </motion.p>
    
    <motion.div
      className="navalur-hcura-action-buttons"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.6 }}
    >
      <Link to="/bookconsultation" className="navalur-hcura-btn-primary">Book Appointment</Link>
      <a href="https://wa.me/918870001377" className="navalur-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp /> WhatsApp Consult
      </a>
    </motion.div>

    <motion.div
      className="navalur-hcura-location-navigation"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.65 }}
    >
      <div className="navalur-hcura-location-header">
        <FaMapMarkerAlt className="navalur-hcura-location-icon" />
        <span className="navalur-hcura-location-title">Our Chennai Locations</span>
      </div>
      
      <div className="navalur-hcura-location-buttons">
        <Link to="/multispecialty-clinic-in-gerugambakkam-chennai" className="navalur-hcura-location-btn">
          <FaDirections />
          <span>Gerugambakkam</span>
        </Link>
        
        <Link to="/multispecialty-clinic-in-valasaravakkam-chennai/" className="navalur-hcura-location-btn">
          <FaDirections />
          <span>Valasaravakkam</span>
        </Link>
        
        <Link to="/multispecialty-clinic-in-tambaram-chennai/" className="navalur-hcura-location-btn">
          <FaDirections />
          <span>Tambaram</span>
        </Link>
        
        <Link to="/multispecialty-clinic-in-chennai/" className="navalur-hcura-location-btn">
          <FaDirections />
          <span>Back</span>
        </Link>
      </div>
    </motion.div>
  </div>
</section>

      <section id="before-after" className="navalur-before-after">
        <div className="navalur-section-header">
          <span className="navalur-section-subtitle">Real Results</span>
          <h2>Before & After Gallery - Navalur Patients</h2>
          <div className="navalur-decorative-line"><span className="navalur-decorative-icon"><FaArrowRight /></span></div>
          <p className="navalur-section-description">Genuine patient transformations from our Navalur clinic — each image shows complete before and after comparison. Click View Details for full gallery.</p>
        </div>

        <div className="navalur-before-tabs">
          {['hair','skin'].map((s, idx) => (
            <button key={s} className={`navalur-ba-tab \${activeService === idx ? 'active' : ''}`} onClick={() => { handleServiceChange(idx); setIsAutoScrollPaused(true); setTimeout(()=>setIsAutoScrollPaused(false),10000); }} aria-pressed={activeService === idx}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>

        <div className="navalur-before-carousel-wrapper">
          <div className="navalur-before-carousel" role="list" aria-label="Before after gallery">
            {(() => {
              const svcKey = activeService === 0 ? 'hair' : 'skin';
              const items = SAMPLE_GALLERY[svcKey] || [];
              
              return items.map((item, idx) => (
                <article key={item.id} className="navalur-ba-clean-card" role="listitem">
                  <div className="navalur-ba-clean-container">
                    <div className="navalur-ba-clean-image-wrapper">
                      <img 
                        src={item.combined} 
                        alt={`${item.title} transformation at H-Cura Navalur`} 
                        className="navalur-ba-clean-image"
                        title={`${item.title} - Before and After Results`}
                      />
                      <div className="navalur-ba-clean-title">
                        <h4>{item.title}</h4>
                      </div>
                    </div>
                    <div className="navalur-ba-clean-actions">
                      <button 
                        className="navalur-ba-clean-view-btn" 
                        onClick={() => openNavalurBaModal(svcKey, idx)}
                        aria-label={`View detailed results for ${item.title}`}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section>

      {navalurBaModalOpen && (
        <div className="navalur-ba-modal" role="dialog" aria-modal="true" aria-label="Before and after detailed gallery">
          <div className="navalur-ba-modal-backdrop" onClick={closeNavalurBaModal} />
          <div className="navalur-ba-modal-panel">
            <header className="navalur-ba-modal-header">
              <h3>Treatment Results Gallery - H-Cura Navalur</h3>
              <button className="navalur-ba-modal-close" onClick={closeNavalurBaModal} aria-label="Close gallery">×</button>
            </header>

            <div className="navalur-ba-modal-body">
              <div className="navalur-ba-scrollable-container">
                <div className="navalur-ba-scroll-track" id="scrollTrack">
                  <div className="navalur-ba-scrollable-grid" id="scrollableGrid">
                    {navalurBaModalItems.map((item, index) => (
                      <div key={item.id} className="navalur-ba-scrollable-card" data-index={index}>
                        <div className="navalur-ba-scrollable-image-container">
                          <img 
                            src={item.combined} 
                            alt={`${item.title} detailed transformation results`} 
                            className="navalur-ba-scrollable-image"
                            title={`${item.title} - Complete Before After Results`}
                          />
                        </div>
                        <div className="navalur-ba-scrollable-content">
                          <h4>{item.title}</h4>
                          <p className="navalur-ba-scrollable-testimonial">"{item.testimonial?.quote || ''}"</p>
                          <div className="navalur-ba-scrollable-author">— {item.testimonial?.author || ''}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="navalur-ba-scroll-progress">
                  <div className="navalur-ba-progress-bar" id="progressBar"></div>
                </div>
              </div>

              <div className="navalur-ba-enhanced-controls">
                <div className="navalur-ba-nav-buttons">
                  <button 
                    className="navalur-ba-nav-btn navalur-ba-prev-btn" 
                    id="prevBtn"
                    onClick={() => scrollGallery('prev')}
                    aria-label="Previous results"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                    </svg>
                    Previous
                  </button>
                  
                  <button 
                    className="navalur-ba-nav-btn navalur-ba-next-btn" 
                    id="nextBtn"
                    onClick={() => scrollGallery('next')}
                    aria-label="Next results"
                  >
                    Next
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <section id="why-choose" className="navalur-why-choose-enhanced">
        <div className="navalur-curved-background">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
        </div>

        <div className="navalur-content-wrapper">
          <motion.div className="navalur-section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <span className="navalur-section-subtitle">Excellence in Healthcare</span>
            <h2>Why Choose H-Cura Clinic in Navalur Chennai?</h2>
            <div className="navalur-decorative-line"><span className="navalur-decorative-icon"><FaShieldAlt /></span></div>
            <p className="navalur-section-description">Because your health, beauty, and confidence deserve a clinic that truly cares. At H-Cura Navalur, we bring together specialist doctors, world-class technology, and a patient-first approach to give you the best possible results. Whether it's restoring your hair, rejuvenating your skin, enhancing your smile, or improving your overall wellness with homeopathy, we focus on treatments that are safe, effective, and tailored just for you. Conveniently located on OMR for Navalur, Sholinganallur, and Perungudi residents, we make advanced healthcare accessible, comfortable, and trustworthy — so you can step in with hope and step out with confidence.</p>
          </motion.div>

          <div className="navalur-awards-banner">
            <div className="navalur-award"><FaStar className="navalur-award-icon" /><span>Best Dermatology Clinic 2024</span></div>
            <div className="navalur-award"><FaCertificate className="navalur-award-icon" /><span>ISO 9001:2015 Certified</span></div>
            <div className="navalur-award"><FaAward className="navalur-award-icon" /><span>Top Healthcare Provider</span></div>
          </div>

          <motion.div className="navalur-features-grid" ref={whyChooseRef} variants={containerVariants} initial="hidden" animate={whyChooseControls}>
            {features.map((feature, index) => (
              <motion.div className="navalur-feature-card-enhanced" key={index} variants={itemVariants}>
                <div className="navalur-feature-header">
                  <div className="navalur-icon-container">{feature.icon}<div className="navalur-icon-glow"></div></div>
                  <span className="navalur-feature-highlight">{feature.highlight}</span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <div className="navalur-feature-footer">
                  <div className="navalur-feature-dots"><span className="navalur-dot"></span><span className="navalur-dot"></span><span className="navalur-dot"></span></div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          <div className="navalur-testimonial-strip">
            <div className="navalur-testimonial-background"></div>
            <div className="navalur-testimonial-content">
              <div className="navalur-quote-marks">"</div>
              <div className="navalur-testimonial-slider">
                {testimonialQuotes.map((quote, index) => (
                  <div className="navalur-testimonial-quote" key={index}><p>{quote}</p></div>
                ))}
              </div>
            </div>
          </div>

          <div className="navalur-stats-container">
            <div className="navalur-stat-box"><div className="navalur-stat-number">5+</div><div className="navalur-stat-label">Years of Excellence</div></div>
            <div className="navalur-stat-box"><div className="navalur-stat-number">10+</div><div className="navalur-stat-label">Medical Experts</div></div>
            <div className="navalur-stat-box"><div className="navalur-stat-number">9k+</div><div className="navalur-stat-label">Happy Patients</div></div>
            <div className="navalur-stat-box"><div className="navalur-stat-number">99%</div><div className="navalur-stat-label">Success Rate</div></div>
          </div>

          <div className="navalur-cta-container">
            <h3>Experience the H-Cura Difference</h3>
            <p>Join thousands of satisfied patients who have transformed their lives with our expert care.</p>
            <Link to="/bookconsultation" className="navalur-cta-button">Book Your Consultation</Link>
          </div>
        </div>

        <div className="navalur-curved-background-bottom">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,181.3C96,203,192,245,288,229.3C384,213,480,139,576,128C672,117,768,171,864,197.3C960,224,1056,224,1152,213.3C1248,203,1344,181,1392,170.7L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path></svg>
        </div>
      </section>

      <section id="services" className="navalur-services-premium-section" ref={sectionRef}>
        <div
          className={`navalur-services-background ${isVisible ? 'visible' : ''}`}
          style={{
            backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.97), rgba(255,255,255,0.8)), url('${servicesBackgroundUrl}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            opacity: isVisible ? 1 : 0
          }}
        ></div>

        <div className="navalur-services-container">
          <div className={`navalur-services-header ${isVisible ? 'visible' : ''}`}>
            <span className="navalur-services-subtitle">Excellence in Healthcare</span>
            <h2>Our Services at H-Cura Navalur Chennai</h2>
            <div className="navalur-services-separator"><span></span><div className="navalur-separator-icon"></div><span></span></div>
            <p className="navalur-services-description">Experience world-class treatments delivered with precision and care. Our comprehensive range of services combines advanced medical technology with natural healing approaches.</p>
          </div>

          <div
            className={`navalur-services-tabs ${isVisible ? 'visible' : ''}`}
            ref={servicesRef}
            onMouseEnter={() => setIsAutoScrollPaused(true)}
            onMouseLeave={() => setIsAutoScrollPaused(false)}
            onFocus={() => setIsAutoScrollPaused(true)}
            onBlur={() => setIsAutoScrollPaused(false)}
          >
            {advancedServices.map((service, index) => {
              const sIcon = serviceIconMap[service.id] || null;
              const isActive = activeService === index;
              return (
                <button
                  key={service.id}
                  className={`navalur-service-tab ${isActive ? 'active' : ''}`}
                  onClick={() => {
                    setIsAutoScrollPaused(true);
                    handleServiceChange(index);
                    setTimeout(() => setIsAutoScrollPaused(false), 10000);
                  }}
                >
                  <span
                    className={`navalur-tab-icon navalur-${service.id}-icon bright-icon`}
                    style={{
                      backgroundImage: sIcon ? `url('${sIcon.url}')` : undefined,
                      backgroundSize: '60% auto',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundColor: sIcon ? sIcon.bgColor : undefined,
                      border: sIcon ? `2px solid ${sIcon.borderColor}` : undefined,
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      display: 'inline-block'
                    }}
                  ></span>
                  <span className="navalur-tab-text">{service.title.split(' ')[0]}</span>
                  {isActive && <span className="navalur-progress-bar"></span>}
                </button>
              );
            })}
          </div>

          <div className="navalur-tab-indicators">
            {advancedServices.map((service, index) => (
              <span
                key={`indicator-${index}`}
                className={`navalur-tab-indicator \${activeService === index ? 'active' : ''}`}
                onClick={() => {
                  setIsAutoScrollPaused(true);
                  handleServiceChange(index);
                  setTimeout(() => setIsAutoScrollPaused(false), 10000);
                }}
              ></span>
            ))}
          </div>

          <div className={`navalur-service-content-wrapper ${isVisible ? 'visible' : ''}`}>
            <div className={`navalur-service-main-content ${isChanging ? 'changing' : ''}`}>
              <div className="navalur-service-info">
                <h3>{advancedServices[activeService].title}</h3>
                <h4>{advancedServices[activeService].subtitle}</h4>
                <p>{advancedServices[activeService].description}</p>

                <div className="navalur-service-cta">
                  <Link to="/bookconsultation" className="navalur-service-btn">Book Consultation</Link>
                  <Link to={serviceLearnMoreUrl(advancedServices[activeService].id)} className="navalur-service-link">
                    Learn More <span className="navalur-arrow-icon">→</span>
                  </Link>
                </div>
              </div>

              <div className="navalur-service-image-container">
                <div className="navalur-service-image-wrapper">
                  <img
                    src={advancedServices[activeService].image}
                    alt={`${advancedServices[activeService].title} at H-Cura Navalur`}
                    className="navalur-service-main-image"
                    title={`${advancedServices[activeService].title} - Advanced Treatment`}
                  />
                  <div className="navalur-image-overlay"></div>
                  <div className="navalur-service-badge"><span>Premium Care</span></div>
                </div>
              </div>
            </div>

            <div className="navalur-service-treatments">
  <h4>Specialized Treatments</h4>
  <div className="navalur-treatments-slider">
    {advancedServices[activeService].treatments.map((treatment, tIndex) => {
      const tIcon = treatmentIconMap[treatment.icon] || null;
      return (
        <div className="navalur-treatment-card" key={tIndex}>
          <div className="navalur-treatment-image">
            {treatment.video ? (
              <video
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '8px'
                }}
              >
                <source src={treatment.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img 
                src={treatment.image} 
                alt={`${treatment.name} at H-Cura Navalur`} 
                title={`${treatment.name} - Professional Treatment`} 
              />
            )}
          </div>
          <div className="navalur-treatment-content">
            <div
              className={`navalur-treatment-icon navalur-${treatment.icon} bright-treatment-icon`}
              style={{
                backgroundImage: tIcon ? `url('${tIcon.url}')` : undefined,
                backgroundSize: '60% auto',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: tIcon ? tIcon.bgColor : undefined,
                border: tIcon ? `2px solid ${tIcon.borderColor}` : undefined,
                width: '56px',
                height: '56px',
                borderRadius: '12px',
              }}
            ></div>
            <h5>{treatment.name}</h5>
            <p>{treatment.description}</p>
            <div className="navalur-treatment-benefits">
              <h6>Benefits:</h6>
              <ul>
                {treatment.benefits.map((benefit, i) => (
                  <li key={i}><span className="navalur-benefit-icon">✓</span>{benefit}</li>
                ))}
              </ul>
            </div>

            <div className="navalur-treatment-cta">
              <Link
                className="navalur-treatment-learnmore"
                to={serviceLearnMoreUrl(advancedServices[activeService].id)}
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      );
    })}
  </div>
</div>

            <div className="navalur-service-testimonial">
              <div className="navalur-testimonial-content">
                <div className="navalur-quote-icon">"</div>
                <p>{advancedServices[activeService].testimonial.quote}</p>
                <div className="navalur-testimonial-author"><strong>{advancedServices[activeService].testimonial.author}</strong> | {advancedServices[activeService].testimonial.location}</div>
              </div>
              <div className="navalur-testimonial-decoration"></div>
            </div>

            <div className="navalur-service-stats">
              <div className="navalur-stat-item"><div className="navalur-stat-number">98<span>%</span></div><div className="navalur-stat-label">Patient Satisfaction</div></div>
              <div className="navalur-stat-item"><div className="navalur-stat-number">5000<span>+</span></div><div className="navalur-stat-label">Successful Treatments</div></div>
              <div className="navalur-stat-item"><div className="navalur-stat-number">15<span>+</span></div><div className="navalur-stat-label">Years Experience</div></div>
              <div className="navalur-stat-item"><div className="navalur-stat-number">12<span>+</span></div><div className="navalur-stat-label">Specialist Doctors</div></div>
            </div>

            <div className="navalur-service-features">
              <div className="navalur-feature">
                <div
                  className="navalur-feature-icon navalur-quality-icon"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  aria-hidden
                >
                  <Icon name="quality-icon" size={28} />
                </div>
                <h5>Premium Quality</h5>
                <p>World-class treatments and technologies</p>
              </div>

              <div className="navalur-feature">
                <div
                  className="navalur-feature-icon navalur-personalized-icon"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  aria-hidden
                >
                  <Icon name="personalized-icon" size={28} />
                </div>
                <h5>Personalized Care</h5>
                <p>Customized treatment plans for each patient</p>
              </div>

              <div className="navalur-feature">
                <div
                  className="navalur-feature-icon navalur-affordable-icon"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  aria-hidden
                >
                  <Icon name="affordable-icon" size={28} />
                </div>
                <h5>Affordable Luxury</h5>
                <p>Premium care at reasonable prices</p>
              </div>
            </div>

            <div className="navalur-service-action">
              <h4>Ready to Experience the H-Cura Difference?</h4>
              <p>Take the first step toward better health and confidence today.</p>
              <div className="navalur-action-buttons">
                <Link to="/bookconsultation" className="navalur-primary-action-btn">Book Appointment</Link>
                <Link to="/contact-us" className="navalur-secondary-action-btn">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="navalur-stats-banner">
        <div className="navalur-stat"><h3>10,000+</h3><p>Happy Patients</p></div>
        <div className="navalur-stat"><h3>5+</h3><p>Years of Excellence</p></div>
        <div className="navalur-stat"><h3>30+</h3><p>Specialist Doctors</p></div>
        <div className="navalur-stat"><h3>4</h3><p>Convenient Locations</p></div>
      </section>

    <section id="locations" className="navalur-locations">
  <div className="navalur-section-header">
    <h2>Our Clinic Locations in Chennai</h2>
    <p>Find the nearest H-Cura clinic for your healthcare needs</p>
  </div>

  <div className="navalur-location-tabs">
    {Object.keys(locations).map((loc) => (
      <Link
        key={loc}
        to={`/multispecialty-clinic-in-${loc}-chennai/`}
        className={`navalur-location-tab ${
          activeLocation === loc ? "active" : ""
        }`}
      >
        <FaMapMarkerAlt /> {locations[loc].name}
      </Link>
    ))}
  </div>

  <div className="navalur-location-details">
    <div className="navalur-location-card">
      <div className="navalur-location-header">
        <h3>{locations[activeLocation].name} Branch</h3>
        <span className="navalur-specialty-tag">
          {locations[activeLocation].specialties}
        </span>
      </div>

      <div className="navalur-location-grid">
        <div className="navalur-location-info">
          <div className="navalur-info-item">
            <FaMapMarkerAlt className="navalur-info-icon" />
            <div>
              <h4>Address</h4>
              <p>{locations[activeLocation].address}</p>
              <p>
                <small>
                  Nearby: {locations[activeLocation].nearbyAreas}
                </small>
              </p>
            </div>
          </div>

          <div className="navalur-info-item">
            <FaPhone className="navalur-info-icon" />
            <div>
              <h4>Contact</h4>
              <p>{locations[activeLocation].phone}</p>
              <button
                className="navalur-contact-button"
                onClick={() =>
                  (window.location.href = `tel:${locations[
                    activeLocation
                  ].phone.replace(/\s+/g, "")}`)
                }
              >
                Call Now
              </button>
            </div>
          </div>

          <div className="navalur-info-item">
            <FaClock className="navalur-info-icon" />
            <div>
              <h4>Working Hours</h4>
              <p>{locations[activeLocation].hours}</p>
            </div>
          </div>
        </div>

        <div className="navalur-popular-services">
          <h4>Popular Services at {locations[activeLocation].name}</h4>
          <ul>
            {locations[activeLocation].popularServices.map(
              (service, index) => (
                <li key={index}>
                  <FaCheckCircle className="navalur-check-icon" />
                  {service}
                </li>
              )
            )}
          </ul>
          <a
            href={locations[activeLocation].mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="navalur-map-link"
          >
            View on Map <FaArrowRight />
          </a>
        </div>
      </div>
    </div>

    <div className="navalur-location-image">
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      >
        <source
          src={
            locations[activeLocation].video ||
            locations[activeLocation].image
          }
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</section>

      <section id="testimonials" className="navalur-testimonials">
        <div className="navalur-section-header"><h2>What Our Patients Say</h2><p>Real experiences from our valued patients</p></div>
        <div className="navalur-testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div className="navalur-testimonial-card" key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: index * 0.2 }}>
              <div className="navalur-testimonial-rating">{[...Array(5)].map((_, i) => (<FaStar key={i} className={i < testimonial.rating ? "navalur-star-filled" : "navalur-star-empty"} />))}</div>
              <p className="navalur-testimonial-text">"{testimonial.text}"</p>
              <div className="navalur-testimonial-author">
                <div className="navalur-author-info" title={`${testimonial.name} • ${testimonial.location} • ${testimonial.service}`}>
                  <h4 className="navalur-testimonial-name">{testimonial.name}</h4>
                  <p className="navalur-testimonial-meta">{testimonial.location} • {testimonial.service}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

     <section
  id="appointment"
  className="navalur-appointment"
  style={{
    position: 'relative',
    color: '#fff',
  }}
>
  <video
    autoPlay
    muted
    loop
    playsInline
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: -2
    }}
  >
    <source src={hcuraHeroVideo2} type="video/mp4" />
  </video>

  <div 
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65))',
      zIndex: -1
    }}
  ></div>

  <div className="navalur-appointment-content" role="region" aria-labelledby="appointment-heading">
    <motion.h2 id="appointment-heading" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>Book Your Appointment Today at H-Cura Navalur</motion.h2>

    <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
      Take the first step toward better health and confidence. Schedule your visit with H-Cura Multispecialty Clinic in Navalur Chennai.
    </motion.p>

    <motion.div className="navalur-contact-options" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
      <div className="navalur-contact-option"><FaPhone /> <span>+91 88700 01377 / 99646 88333</span></div>
      <div className="navalur-contact-option"><FaGlobe /> <a href="https://h-cura.com" target="_blank" rel="noopener noreferrer">www.h-cura.com</a></div>
    </motion.div>

    <motion.div className="navalur-appointment-buttons" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
      <Link to="/bookconsultation" className="navalur-primary-button">Schedule Consultation</Link>
      <a href="https://wa.me/918870001377" className="navalur-whatsapp-button" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp Us</a>
    </motion.div>
  </div>
</section>

    </div>
  );
};

export default HCuraNavalur;






